import { FinancialReviewFormEdit } from 'features/FinancialReview/pages';
import Layout from 'layout';
import { Can } from 'components/Can';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function FinancialReviewFormEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="update" on="financial_review">
          <FinancialReviewFormEdit />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
